import { ChangeDetectionStrategy, Component, Input, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'ca-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconComponent {
    @Input() set name(iconName: string) {
        this.iconPath = `assets/images/icons/${this.domSanitizer.sanitize(SecurityContext.HTML, iconName)}.svg`;
    }

    @Input() removeSVGAttributes: string[] = ['fill', 'stroke'];
    @Input() highlightMode = 'fill';
    @Input() highlightColor = 'currentColor';
    @Input() size: 'l' | 'm' | 's' | 'xs' = 's';

    @Input() animationClass: { [key: string]: boolean };
    @Input() title;

    iconPath: string;

    get classes() {
        return {
            'size-l': this.isLargeSize,
            'size-m': this.isMediumSize,
            'size-s': this.isSmallSize,
            'size-xs': this.isExtraSmallSize,
            ...(this.animationClass && this.animationClass),
        };
    }

    get isFillHighlightMode(): boolean {
        return this.highlightMode === 'fill';
    }

    get isStrokeHighlightMode(): boolean {
        return this.highlightMode === 'stroke';
    }

    get isLargeSize(): boolean {
        return this.size === 'l';
    }
    get isMediumSize(): boolean {
        return this.size === 'm';
    }

    get isSmallSize(): boolean {
        return this.size === 's';
    }
    get isExtraSmallSize(): boolean {
        return this.size === 'xs';
    }

    constructor(private domSanitizer: DomSanitizer) {}
}
